__turbopack_context__.v({
  "cell": "FqBeWW_cell",
  "gradient": "FqBeWW_gradient",
  "grid": "FqBeWW_grid",
  "inner": "FqBeWW_inner",
  "label": "FqBeWW_label",
  "note": "FqBeWW_note",
  "noteText": "FqBeWW_noteText",
  "section": "FqBeWW_section",
  "shader": "FqBeWW_shader",
  "top": "FqBeWW_top",
  "value": "FqBeWW_value",
});
